export default {
  hero_eyebrow: "THE USFANS SPREADSHEET RESOURCE HUB",
  hero_h1: "USFans Spreadsheet — Guides, Finds, Reviews & Resources",
  hero_copy:
    "Explore the latest USFans Spreadsheet resources in one organized hub. Discover useful guides, product information, shipping insights, reviews and safety resources — designed to make your research faster and easier.",
  hero_cta_primary: "Explore USFans Spreadsheet",
  hero_cta_secondary: "Browse Latest Guides",
  hero_trust: "Independent resource · Updated regularly · Multilingual",
  // Main site buttons
  main_btn_1: "usfans spreadsheet",
  main_btn_2: "buy it now",
  // Category dropdown
  dropdown_label: "Browse Categories",
  dropdown_placeholder: "Select a category…",
  // Category grid
  categories_title: "Shop by Category",
  categories_subtitle: "Jump straight to the category you are looking for on the main website.",
  // Text module
  text_eyebrow: "ABOUT USFANS SPREADSHEET",
  text_title: "What Is the USFans Spreadsheet?",
  text_p1:
    "The USFans spreadsheet is an organized, community-style resource that gathers product links, finds and references in one place. Instead of searching scattered posts and messages, people use it as a single starting point to browse categories, compare options and follow leads toward the products they are interested in.",
  text_p2:
    "A good spreadsheet resource saves time because it groups items into clear categories — shoes, hoodies, t-shirts, jackets and more — and points each entry toward its source. This makes it much easier to move from research to actually exploring the full selection on the main website.",
  text_p3:
    "Because the spreadsheet is an independent resource, it is always wise to verify links, check current prices and read product details directly on the source website before making any decision.",
  text_features_title: "Why a Spreadsheet Helps",
  text_feature_1_title: "Organized discovery",
  text_feature_1_desc: "Categories keep products grouped so you can find what you need quickly.",
  text_feature_2_title: "Faster research",
  text_feature_2_desc: "One hub replaces hours of scrolling through scattered information.",
  text_feature_3_title: "Clear next steps",
  text_feature_3_desc: "Each entry points you toward the source website for full details.",
  // Article entry
  article_entry_title: "Featured Guides",
  article_entry_subtitle: "Original, in-depth articles written around the USFans spreadsheet topic.",
  article_1_tag: "Safety",
  article_1_title: "Is USFans Legit? Safety, Reviews & What to Know",
  article_1_desc:
    "An honest look at how to verify the USFans spreadsheet, spot warning signs and protect yourself while researching online.",
  article_1_cta: "Read Guide",
  // Safety
  safety_title: "USFans Safety & Security",
  safety_copy:
    "Before using any online resource, verify the website address, avoid suspicious downloads, protect your account credentials and independently verify important information. This website is an independent informational resource and does not guarantee third-party services, products or transactions.",
  safety_cta: "Read the USFans Safety Guide",
  // CTA
  cta_title: "Ready to Explore More?",
  cta_copy:
    "Use our guides and spreadsheet resources to research your options, then continue to the main website when you are ready to explore the complete experience.",
  cta_primary: "Visit Main Website",
  cta_secondary: "Explore More USFans Guides",
  // FAQ
  faq_title: "USFans Spreadsheet FAQ",
  faq_q1: "What is a USFans spreadsheet?",
  faq_a1:
    "It is an organized resource that collects product links, finds and references into a single, easy-to-browse hub, grouped by category.",
  faq_q2: "How does a USFans spreadsheet work?",
  faq_a2:
    "Items are grouped into categories and each entry points toward its source on the main website, so you can jump from research to browsing in one click.",
  faq_q3: "Is USFans legit?",
  faq_a3:
    "USFansLink is an independent resource. Always verify links, prices and product details directly on the source website before making a decision.",
  faq_q4: "What should I know about USFans shipping cost?",
  faq_a4:
    "Shipping cost depends on the source website, your location and the chosen shipping method. Check the checkout page for the most accurate estimate.",
  faq_q5: "Does USFans offer coupons?",
  faq_a5:
    "Promotions and discount codes, when available, are typically shown on the source website. Verify any code before using it.",
  faq_q6: "Where can I find USFans discount codes?",
  faq_a6:
    "Discount codes are usually listed directly on the main website or in its promotion sections. Treat unofficial codes with caution.",
  faq_q7: "What is the USFans warehouse?",
  faq_a7:
    "The warehouse refers to the storage and fulfillment side of the source website. For accurate details, refer to the source website's shipping and order information.",
  faq_q8: "How should I check USFans information?",
  faq_a8:
    "Cross-check important details directly on the official source website, and be cautious of unofficial third-party claims.",
};